// extracted by mini-css-extract-plugin
export default {"register-form":"RenewPasswordForm_register-form__gVmre","input-style":"RenewPasswordForm_input-style__Uan7H","btn-style":"RenewPasswordForm_btn-style__OKEPV"};